var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header bg-utel-v2-secondary text-primary"},[_c('h5',{staticClass:"modal-title"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","aria-label":"Cerrar"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n    ×\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }